var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../../utils/utils';
export class FunnelMixedFilter {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get mixed() {
        return this.parent;
    }
    get app() {
        return this.mixed.app;
    }
    get filteredMixedMiniQuestions() {
        return this.passAll;
    }
    get allMiniQuestions() {
        return this.app.funnel.funnelIncoming.allMiniQuestions;
    }
    get passAll() {
        return this.passBlockedQuestionStates.filter(mini => this.passBlockedQuestiontypes.includes(mini) && this.passBlockedTags.includes(mini));
    }
    get passBlockedTags() {
        return this.allMiniQuestions.filter(q => !this.tagsFilteredByUser.includes(q.subtopicName));
    }
    get passBlockedQuestiontypes() {
        return this.allMiniQuestions.filter(q => !this.questiontypesFilteredByUser.includes(q.micro.questionType));
    }
    get passBlockedQuestionStates() {
        return this.allMiniQuestions.filter(q => q.miniPassState.questionState && !this.questionstatesFilteredByUser.includes(q.miniPassState.questionState));
    }
    get tagsFilteredByUser() {
        return this.app.topic.topicFilter.filterTagQuery.streamedDeep.map(v => v.tag);
    }
    get questiontypesFilteredByUser() {
        return this.app.topic.topicFilter.filterQuestiontypeQuery.streamedDeep.map(v => v.questionType);
    }
    /* USED FOR NUMBER PREVIEWS */
    get filteredUnlessTag() {
        return this.passBlockedQuestionStates.filter(mini => this.passBlockedQuestiontypes.includes(mini));
    }
    get filteredUnlessQuestiontype() {
        return this.passBlockedQuestionStates.filter(mini => this.passBlockedTags.includes(mini));
    }
    get filteredUnlessQuestionstate() {
        return this.passBlockedQuestiontypes.filter(mini => this.passBlockedTags.includes(mini));
    }
    /* USED FOR NUMBER PREVIEWS */
    get questionstatesFilteredByUser() {
        return this.app.topic.topicFilter.questionPassStates.filter(passState => passState.isFiltered).map(passState => passState.id);
    }
    get numberOfAvailableQuestions() {
        return this.allMiniQuestions.length;
    }
    get numberOfRemainingQuestions() {
        return this.filteredMixedMiniQuestions.length;
    }
    get numberOfFilteredQuestions() {
        return this.numberOfAvailableQuestions - this.numberOfRemainingQuestions;
    }
    get hasNoMoreQuestions() {
        return this.numberOfRemainingQuestions === 0;
    }
}
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "passAll", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "passBlockedTags", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "passBlockedQuestiontypes", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "passBlockedQuestionStates", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "tagsFilteredByUser", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "questiontypesFilteredByUser", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "filteredUnlessTag", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "filteredUnlessQuestiontype", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "filteredUnlessQuestionstate", null);
__decorate([
    cachedSet
], FunnelMixedFilter.prototype, "questionstatesFilteredByUser", null);
